// extracted by mini-css-extract-plugin
export default {"customSelect":"CustomSelect_customSelect__dj-RW"};